var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DATA_SOURCE_SERVICE } from '../../../core/data-source/data-source.service';
import { DataSourceIdentifier } from '../../../core/data-source/data-source-identifier';
import { AppComponentBase } from '../../../../../shared/app-component-base';
var DataSourceComboComponent = /** @class */ (function (_super) {
    __extends(DataSourceComboComponent, _super);
    function DataSourceComboComponent(injector, dataSourceService) {
        var _this = _super.call(this, injector) || this;
        _this.dataSourceService = dataSourceService;
        _this.selectedDataSourceIdChange = new EventEmitter();
        _this.dataSources = [];
        return _this;
    }
    Object.defineProperty(DataSourceComboComponent.prototype, "selectedDataSourceId", {
        get: function () {
            return this._selectedDataSourceId;
        },
        set: function (v) {
            if (DataSourceIdentifier.equals(this._selectedDataSourceId, v)) {
                return;
            }
            this._selectedDataSourceId = v;
            this.selectedDataSourceIdChange.emit(v);
        },
        enumerable: true,
        configurable: true
    });
    DataSourceComboComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.dataSourceService.getDataSources()
            .pipe(finalize(function () { _this.loading = false; }))
            .subscribe(function (data) {
            _this.dataSources = data;
            if (_this.selectedDataSourceId === undefined || !_this.contain(data, _this.selectedDataSourceId)) {
                if (_this.dataSources.length > 0) {
                    _this.selectedDataSourceId = _this.dataSources[0].id;
                }
            }
        });
    };
    DataSourceComboComponent.prototype.compare = function (x, y) {
        return DataSourceIdentifier.equals(x, y);
    };
    DataSourceComboComponent.prototype.contain = function (dataSources, dataSourceId) {
        var result = dataSources.find(function (d) {
            return d.id.code === dataSourceId.code;
        });
        if (result) {
            return true;
        }
        return false;
    };
    __decorate([
        Input()
    ], DataSourceComboComponent.prototype, "selectedDataSourceId", null);
    __decorate([
        Output()
    ], DataSourceComboComponent.prototype, "selectedDataSourceIdChange", void 0);
    DataSourceComboComponent = __decorate([
        Component({
            selector: 'data-source-combo',
            template: "<div [busyIf]=\"loading\" class=\"dsContainer\"> <select class=\"form-control\" [compareWith]=\"compare\"  [(ngModel)]=\"selectedDataSourceId\"> <option *ngFor=\"let dataSource of dataSources\" [ngValue]=\"dataSource.id\">{{dataSource.name}}</option> </select> </div> "
        }),
        __param(1, Inject(DATA_SOURCE_SERVICE))
    ], DataSourceComboComponent);
    return DataSourceComboComponent;
}(AppComponentBase));
export { DataSourceComboComponent };
